<div class="component cl-1 rw-2">
  <div class="cl-1 title">
    <h1>{{ info.greet }}</h1>
  </div>
  <div class="cl-2 info">
    <div class="content-card">
      <p>{{ info.experience }}</p>
      <p>{{ info.experience2 }}</p>
    </div>
    <div class="content-card">
      <p>{{ info.work }}</p>
    </div>
  </div>
</div>
